export function errorTemplate(trace: string, fetchedURL: string) {
	// turn script into a data URI so we don"t have to escape any HTML values
	const script = `
        console.error("Error loading URL:\\n", ${JSON.stringify(fetchedURL)}, "\\nTrace:\\n", ${JSON.stringify(trace)});
        const btn = document.getElementById("reload");
        const label = document.getElementById("label");

        const DISABLE_TIME = 10;
        const STORAGE_KEY = "reload_disabled_until";

        function updateButton() {
            const now = Date.now();
            const disabledUntil = parseInt(localStorage.getItem(STORAGE_KEY), 10);

            if (disabledUntil && now < disabledUntil) {
                btn.disabled = true;

                let timeLeft = Math.ceil((disabledUntil - now) / 1000);
                label.textContent = timeLeft + "s";

                const timer = setInterval(() => {
                    timeLeft--;
                    if (timeLeft <= 0) {
                        clearInterval(timer);
                        btn.disabled = false;
                        label.textContent = "Reload";
                        localStorage.removeItem(STORAGE_KEY);
                    } else {
                        label.textContent = timeLeft + "s";
                    }
                }, 1000);

            } else {
                btn.disabled = false;
                label.textContent = "Reload";
                localStorage.removeItem(STORAGE_KEY);
            }
        }

        btn.addEventListener("click", () => {
            localStorage.setItem(STORAGE_KEY, Date.now() + DISABLE_TIME * 1000);

            updateButton();

            location.reload();
        });

        updateButton();
        `;

	return `
<!DOCTYPE html>
<html>
    <head>
        <meta charset="utf-8" />
        <title>Oops!</title>
        <style>
            :root {
                --deep: #080602;
                --shallow: #181412;
                --beach: #f1e8e1;
                --shore: #b1a8a1;
                --accent: #ffa938;
                --font-sans: -apple-system, system-ui, BlinkMacSystemFont, sans-serif;
                --font-monospace: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
            }

            *:not(div,p,span,ul,li,i,span) {
                background-color: var(--deep);
                color: var(--beach);
                font-family: var(--font-sans);
            }

            textarea,
            button {
                background-color: var(--shallow);
                border-radius: 0.6em;
                padding: 0.6em;
                border: none;
                appearance: none;
                font-family: var(--font-sans);
                color: var(--beach);
            }

            button.primary {
                background-color: var(--accent);
                color: var(--deep);
                font-weight: bold;
            }

            textarea {
                resize: none;
                height: 20em;
                text-align: left;
                font-family: var(--font-monospace);
            }

            body {
                width: 100vw;
                height: 100vh;
                justify-content: center;
                align-items: center;
            }

            body,
            html,
            #inner {
                display: flex;
                align-items: center;
                flex-direction: column;
                gap: 0.5em;
                overflow: hidden;
            }

            #inner {
                z-index: 100;
            }

            #cover {
                position: absolute;
                width: 100%;
                height: 100%;
                background-color: color-mix(in srgb, var(--deep) 70%, transparent);
                z-index: 99;
            }
            button {
                background-color: var(--shallow);
                border-radius: 0.6em;
                padding: 0.6em 1.2em;
                border: none;
                appearance: none;
                font-family: var(--font-sans);
                color: var(--beach);
                cursor: pointer;
                transition: transform 0.15s ease, opacity 0.15s ease, background 0.2s ease;
            }

            button.primary {
                background-color: var(--accent);
                color: var(--deep);
                font-weight: bold;
            }

            /* Hover animation */
            button:hover {
                transform: scale(1.05);
            }

            /* Click animation */
            button:active {
                transform: scale(0.92);
                opacity: 0.8;
            }

            button:disabled {
                opacity: 0.5;
                cursor: not-allowed;
                transform: none !important;
            }

            #reload {
                min-width: 90px;
                text-align: center;
            }

            </style>
    </head>
    <body>
        <div id="cover"></div>
        <div id="inner">
            <h1 id="errorTitle">Oops! Something went wrong.</h1>
            <br>
            <button id="reload" class="primary">
                <span id="label">Reload</span>
            </button>
        </div>
        <script src="${"data:application/javascript," + encodeURIComponent(script)}"></script>
    </body>
</html>
        `;
}

export function renderError(err: unknown, fetchedURL: string) {
	const headers = {
		"content-type": "text/html",
	};
	if (crossOriginIsolated) {
		headers["Cross-Origin-Embedder-Policy"] = "require-corp";
	}

	return new Response(errorTemplate(String(err), fetchedURL), {
		status: 500,
		headers: headers,
	});
}